export enum DepositStep {
  StartPrepare = 'StartPrepare',
  StartRedirect = 'StartRedirect',
  StartParseResultRedirect = 'StartParseResultRedirect',
  SendTransaction = 'SendTransaction',
  TransactionUnavailable = 'TransactionUnavailable',
  Error = 'Error',
  Success = 'Success'
}

export enum TransactionStatus {
  Success = 'Success',
  Error = 'Error',
  Unavailable = 'Unavailable'
}